module.exports = __webpack_public_path__ + "img/b3.9c0a710c.jpg";